import React from 'react';

const IconLogo = () => (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="310.000000pt" height="310.000000pt" viewBox="0 0 310.000000 310.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,310.000000) scale(0.100000,-0.100000)"
stroke="none" fill="#64ffda">
<path d="M1505 3070 c-16 -4 -65 -28 -108 -54 -43 -25 -79 -46 -81 -46 -4 0
-149 -83 -176 -100 -8 -6 -22 -13 -30 -17 -8 -4 -48 -26 -88 -50 -41 -24 -75
-43 -77 -43 -2 0 -54 -29 -115 -65 -61 -36 -113 -65 -115 -65 -4 0 -149 -83
-175 -100 -8 -6 -22 -13 -30 -17 -8 -4 -37 -20 -65 -36 -27 -16 -79 -45 -115
-64 -90 -49 -117 -79 -125 -145 -3 -29 -5 -367 -3 -750 3 -689 3 -697 24 -725
17 -22 637 -403 779 -478 17 -9 44 -25 60 -35 17 -11 39 -24 50 -30 11 -6 29
-16 40 -23 11 -7 62 -37 113 -67 51 -30 114 -68 140 -83 121 -72 151 -72 278
3 47 28 86 50 88 50 3 0 39 20 80 45 42 25 78 45 80 45 3 0 50 27 106 60 56
33 103 60 105 60 2 0 54 29 115 65 61 36 113 65 115 65 2 0 38 20 79 45 42 25
78 45 80 45 3 0 49 26 103 58 54 31 115 66 136 77 21 11 54 35 73 54 l34 34 0
749 0 748 -32 34 c-25 26 -611 383 -688 419 -8 4 -28 16 -45 27 -16 11 -39 24
-50 30 -11 6 -36 20 -55 31 -263 158 -421 247 -445 251 -16 3 -43 2 -60 -2z
m-7 -986 c25 -17 31 -74 9 -92 -6 -6 -39 -14 -72 -19 l-60 -8 -3 -173 c-1 -94
1 -172 5 -172 15 1 47 30 195 177 84 83 148 153 146 161 -2 9 -16 19 -32 23
-16 5 -33 14 -37 21 -14 21 -10 60 8 80 14 16 34 18 174 18 150 0 159 -1 179
-22 38 -41 14 -92 -48 -103 -21 -3 -51 -17 -68 -31 -67 -58 -304 -298 -304
-310 0 -6 13 -17 29 -24 43 -17 116 -93 168 -174 62 -97 65 -102 108 -181 49
-91 62 -105 97 -105 32 0 68 -31 68 -59 0 -53 -79 -85 -160 -64 -41 11 -61 38
-145 198 -94 178 -136 236 -198 273 -65 39 -82 37 -137 -14 l-51 -47 3 -141 3
-141 63 -5 c69 -6 82 -16 82 -66 0 -56 -13 -59 -226 -59 -181 0 -194 1 -208
20 -21 27 -20 68 2 88 11 10 40 17 77 19 l60 3 0 405 0 405 -65 8 c-68 8 -90
23 -90 62 0 11 7 31 16 43 15 21 20 22 202 22 154 0 192 -3 210 -16z"/>
</g>
</svg>

);

export default IconLogo;
